import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAlertCircle, FiX } = FiIcons;

const ErrorAlert = ({ error, onDismiss }) => {
  return (
    <AnimatePresence>
      {error && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg flex items-center justify-between"
        >
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiAlertCircle} className="text-red-500" />
            <span>{error}</span>
          </div>
          <button
            onClick={onDismiss}
            className="text-red-500 hover:text-red-700"
          >
            <SafeIcon icon={FiX} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ErrorAlert;